import { Box, Container, CssBaseline, Grid } from "@mui/material";
import { Applications } from "configs";
import { useShouldRenderPageGuard } from "hooks/useShouldRenderPageGuard";
import { appDefaultRoute, appPrefix } from "pages/app-cycle-ways";
import { useEffect, useRef } from "react";
import { Navigate, Outlet, useMatch } from "react-router-dom";
import { setRootPath } from "reducers/auth.reducer";
import { useAppDispatch } from "store";
import LoadingLayout from "layouts/common/loader/LoadingLayout.tsx";
import { clearLocations, setLocations } from "reducers/newLocation.reducer";
import { newExecuteRetrieveLocationsRequest } from "api/common/side-panel.api";
import { useSelector } from "react-redux";
import { LoadingWrapper } from "components/wrappers/LoadingWrapper";
import NavbarCycleWays from "./header/NavbarCycleWays";

const { AppIdCycleways } = Applications;

export default function DeviceMonitorLayout(): JSX.Element {
    const match = useMatch(appPrefix);
    const { shouldRender } = useShouldRenderPageGuard(AppIdCycleways);
    const { locationsTree } = useSelector((state) => state.newLocation);
    const dispatch = useAppDispatch();
    const locationsAbortControllerRef = useRef<AbortController | null>(null);

    useEffect(() => {
        dispatch(setRootPath("/cycle-ways/home"));
    }, []);

    useEffect(() => {
        (async () => {
            dispatch(clearLocations());
            await getLocations();
        })();

        return () => {
            locationsAbortControllerRef.current?.abort();
        };
    }, []);

    const getLocations = async () => {
        try {
            locationsAbortControllerRef.current = new AbortController();
            const locationSignal = locationsAbortControllerRef.current.signal;

            const locationsResponse = await newExecuteRetrieveLocationsRequest({
                signal: locationSignal,
            });

            if (locationsResponse && Array.isArray(locationsResponse)) {
                dispatch(setLocations(locationsResponse));
            }
        } catch (e) {
            console.log(e);
        }
    };

    if (match) return <Navigate to={appDefaultRoute} replace />;

    return shouldRender ? (
        <Container maxWidth="xl" disableGutters>
            <CssBaseline />
            <NavbarCycleWays />
            <Grid className="custom-container">
                {locationsTree.length > 0 ? (
                    <Box
                        sx={{
                            position: "relative",
                            height: "100%",
                            transition: "all 0.5s ease",
                            padding: "25px",
                            boxSizing: "border-box",
                        }}
                    >
                        <Outlet />
                    </Box>
                ) : (
                    <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
                        <LoadingWrapper isLoading />
                    </Box>
                )}
            </Grid>
        </Container>
    ) : (
        <LoadingLayout />
    );
}
